import { ModalForm } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import useEngineeringService from '../useEngineeringService';
import { EngineeringIncidentReport, SaveIncidentPayload } from '../types';
import { modalActionsSx } from '../shared/modalActionsSx';
import IncidentForm from './IncidentForm';
import { incidentValidation } from './incidentValidation';

interface UpdateIncidentModalProps {
  projectId: string;
  incident: EngineeringIncidentReport | null;
  isOpen: boolean;
  onClose: () => void;
  onSaved: (incident: EngineeringIncidentReport) => void;
}

const UpdateIncidentModal = ({ projectId, incident, isOpen, onClose, onSaved }: UpdateIncidentModalProps) => {
  const { updateIncident } = useEngineeringService();

  if (!incident) return null;

  return (
    <Modal isOpen={isOpen} onToggle={onClose} title="Update incident">
      <ModalForm
        modalOpen={isOpen}
        closeModal={onClose}
        submitButtonText="Update"
        actionsSx={modalActionsSx}
        getDataFunc={() => {
          const { shortDescription, severity, linkToDetails, notes } = incident;
          return Promise.resolve({
            shortDescription: shortDescription ?? '',
            severity: severity ?? null,
            linkToDetails: linkToDetails ?? '',
            notes: notes || '',
          });
        }}
        submitFormFunc={async values => {
          const { shortDescription, severity, linkToDetails, notes } = values;
          const payload: SaveIncidentPayload = {
            id: incident.id,
            shortDescription,
            severity,
            linkToDetails: linkToDetails || null,
            notes,
          };
          return { result: await updateIncident(projectId, incident.id, payload) };
        }}
        afterSubmit={{
          message: 'You are awesome! Incident has been successfully updated.',
          execute: (response: { result: EngineeringIncidentReport }) => onSaved(response.result),
        }}
        getValidationSchemaFunc={() => Promise.resolve(incidentValidation)}
      >
        <IncidentForm />
      </ModalForm>
    </Modal>
  );
};

export default UpdateIncidentModal;
